var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('bb-spinner')],1):_vm._e(),(_vm.visible)?_c('pay-back',{attrs:{"visible":_vm.visible,"is-mobile-app":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }